import React, { useState, useCallback } from 'react';
import { Switch, Typography } from 'ui-kit';
import { message } from 'antd';
import _ from 'lodash';

import useMediaQuery from 'hooks/useMediaQuery';
import { useLoadingBackdrop } from 'hooks/useLoadingBackdrop';
import { productActiveUpdate } from 'api/product_sdk';
import { MEDIA_QUERIES } from 'consts';

interface IActiveProduct {
  isActive: boolean;
  productId: number;
  onUpdate: () => void;
}

const ActiveProduct = ({ isActive, productId, onUpdate }: IActiveProduct) => {
  const [showLoading, hideLoading] = useLoadingBackdrop();

  const [active, setActive] = useState(isActive);
  const matches = useMediaQuery(MEDIA_QUERIES.md);

  const renderContent = () => {
    const status = <b>{active ? 'Active' : 'Inactive'}</b>;
    if (!matches) {
      return status;
    }

    return <>This item is {status}</>;
  };

  const handleChangeStatus = useCallback(
    (event) => {
      showLoading();
      const status = event.target.checked;

      setActive(status);
      productActiveUpdate({ productId, isActive: status })
        .then(() => {
          message.success("Product's status was successfully updated.");
          onUpdate();
          hideLoading();
        })
        .catch((error) => {
          setActive(isActive);
          message.error(error.message || 'Something went wrong! Please try again later');
          hideLoading();
        });
    },
    [showLoading, hideLoading, productId, onUpdate, isActive],
  );

  return (
    <Typography variant="body1" className="ProductCardAdmin-actions__active">
      <span data-walkthrough="product-toggle">
        <Switch
          color="secondary"
          size="small"
          checked={active}
          onClick={(e) => {
            e.stopPropagation();
          }}
          onChange={handleChangeStatus}
        />
      </span>
      {renderContent()}
    </Typography>
  );
};

export default ActiveProduct;
